//todo: make vue store
import { i18n } from '../main.js';

let utils = {
    getByType(type, {currencies, accounts, parties} = {}) {
        switch (type) {
            case "Process":
                return {
                    fields: [
                        {
                            caption: "Progress",
                            name: "progress",
                            type: "float",
                            precision: 0
                        },
                        {
                            caption: "Definition",
                            name: "definitionId",
                            type: "string"
                        },
                        {
                            caption: "Last message",
                            name: "lastMessage",
                            type: "string"
                        },
                        {
                            caption: "Start timestamp",
                            name: "startTime",
                            type: "date"
                        },
                        {
                            caption: "End timestamp",
                            name: "endTime",
                            type: "date"
                        }

                    ]
                }
            case "importFile":
                return {
                    fields: [
                        {
                            caption: 'Kategorie',
                            name: "category",
                            type: "string",
                        },

                    ]
                };
            case "account":
                return {
                    fields: [
                        {
                            caption: i18n.t('accounts.account'),
                            name: "id",
                            type: "entity",
                            object: "account",
                            options: accounts
                        },
                        {
                            caption: i18n.t('accounts.name'),
                            name: "name",
                            type: "string"
                        },
                        {
                            caption: i18n.t('accounts.alias'),
                            name: "alias",
                            type: "string"
                        },
                        {
                            caption: i18n.t('accounts.eBankingName'),
                            name: "eBankingAccountNumber",
                            type: "string"
                        },
                        {
                            caption: i18n.t('accounts.internal'),
                            name: "internal",
                            type: "boolean"
                        },
                        {
                            caption: i18n.t('accounts.type'),
                            name: "type",
                            type: "string"
                        },
                        {
                            caption: i18n.t('accounts.number'),
                            name: "accountNumber",
                            type: "string"
                        },

                        {
                            caption: i18n.t('accounts.bank'),
                            name: "bankId",
                            type: "entity",
                            object: "party",
                            options: parties
                        },
                        {
                            caption: i18n.t('accounts.iban'),
                            name: "iban",
                            type: "string"
                        },
                        {
                            caption: i18n.t('accounts.currency'),
                            name: "currency",
                            type: "entity",
                            object: "currency",
                            options: currencies
                        },
                        {
                            caption: i18n.t('accounts.location'),
                            name: "geoPoint",
                            type: "geo_point"
                        },
                        {
                            caption: i18n.t('accounts.active'),
                            name: "active",
                            type: "boolean"
                        }
                    ]
                };
            case "creditRisk":
                return {
                    fields: [
                        {
                            caption: "CounterParty",
                            name: "counterParty",
                            type: "string"
                        }
                    ]
                };
            case "cashEffect":
                return {
                    fields: [
                        {
                            caption: "Id",
                            name: "id",
                            type: "uuid"
                        },
                        {
                            caption: "Name",
                            name: "name",
                            type: "string"
                        },
                        {
                            caption: "Category",
                            name: "category",
                            type: "string"
                        }
                    ]
                }
            case "cashEvent":
                return {
                    fields: [
                        {
                            caption: "Id",
                            name: "id",
                            type: "uuid"
                        },
                        {
                            caption: i18n.t('reconciliation.operation'),
                            name: "operation",
                            type: "uuid"
                        },
                        {
                            caption: i18n.t('accountBalancesItems.amount'),
                            name: "amount",
                            type: "float",
                            precision: 2
                        },
                        {
                            caption: i18n.t('accounts.currency'),
                            name: "currency",
                            type: "entity",
                            object: "currency",
                            options: currencies
                        },
                        {
                            caption: i18n.t('accounts.account'),
                            name: "account",
                            type: "entity",
                            object: "account",
                            options: accounts
                        },
                        {
                            caption: i18n.t('reconciliation.plannedDate'),
                            name: "timestamp",
                            type: "date"
                        },
                        {
                            caption: i18n.t('reconciliation.realizationDate'),
                            name: "realization",
                            type: "date"
                        },
                        {
                            caption: i18n.t('accountBalancesItems.counterAccount'),
                            name: "counteraccount",
                            type: "entity",
                            object: "account",
                            options: accounts
                        },
                        {
                            caption: i18n.t('reconciliation.counterparty'),
                            name: "counterparty",
                            type: "entity",
                            object: "party",
                            options: parties
                        },
                        {
                            caption: i18n.t('type'),
                            name: "type",
                            type: "string"
                        },
                        {
                            caption: i18n.t('source'),
                            name: "source",
                            type: "string"
                        },
                        {
                            caption: i18n.t('cashEvents.category'),
                            name: "category",
                            type: "string"
                        },
                        {
                            caption: i18n.t('cashEvents.subcategory'),
                            name: "subcategory",
                            type: "string"
                        },
                        {
                            caption: i18n.t('reconciliation.transactionReference'),
                            name: "transactionReference",
                            type: "string"
                        }
                    ]
                }
            case "reconciliationMatch":
                return {
                    fields: [
                        {
                            caption: i18n.t('type'),
                            name: "type",
                            type: "entity",
                            options: [{
                                id: "MANUAL",
                                name: i18n.t('reconciliation.manual')
                            }, {
                                id: "AUTOMATIC",
                                name: i18n.t('reconciliation.automatic')
                            }]
                        },
                        {
                            caption: i18n.t('reconciliation.transactionReference'),
                            name: "cashEventDto.transactionReference",
                            type: "string"
                        }
                    ]
                }
            case "accountBalance":
                return {
                    fields: [
                        {
                            caption: "Id",
                            name: "id",
                            type: "uuid"
                        }, {
                            caption: i18n.t('accounts.account'),
                            name: "accountId",
                            type: "entity",
                            object: "account",
                            options: accounts
                        },
                        {
                            caption: i18n.t('accountBalances.startBalance'),
                            name: "startBalance",
                            type: "float"
                        },
                        {
                            caption: i18n.t('accountBalances.endBalance'),
                            name: "endBalance",
                            type: "float",
                        },
                        {
                            caption: i18n.t('accounts.balanceDate'),
                            name: "balanceDate",
                            type: "date"
                        }

                    ]
                };
            case "accountBalanceItem":
                return {
                    fields: [
                        {
                            caption: "Id",
                            name: "id",
                            type: "uuid"
                        },
                        {
                            caption: i18n.t('accounts.account'),
                            name: "account",
                            type: "entity",
                            object: "account",
                            options: accounts
                        },
                        {
                            caption: i18n.t('accountBalancesItems.amount'),
                            name: "amount",
                            type: "float",
                            precision: 2
                        },
                        {
                            caption: i18n.t('accounts.internal'),
                            name: "internalTransfer",
                            type: "entity",
                            options: [{id: true, name: "Yes"}, {id: false, name: "No"}]
                        },
                        {
                            caption: i18n.t('date'),
                            name: "balanceDate",
                            type: "date"
                        },
                        {
                            caption: i18n.t('accounts.currency'),
                            name: "currency",
                            type: "entity",
                            object: "currency",
                            options: currencies
                        },
                        {
                            caption: i18n.t('accountBalancesItems.counterAccount'),
                            name: "counterAccount",
                            object: "account",
                            type: "string"
                        },
                        {
                            caption: i18n.t('accountBalancesItems.counterAccountName'),
                            name: "counterAccountName",
                            type: "string"
                        },
                        {
                            caption: i18n.t('accountBalancesItems.counterAccountBankCode'),
                            name: "counterAccountBankCode",
                            type: "string"
                        },
                        {
                            caption: i18n.t('accountBalancesItems.message'),
                            name: "message",
                            type: "string"
                        },
                        {
                            caption: i18n.t('accountBalancesItems.variableSymbol'),
                            name: "variableSymbol",
                            type: "string"
                        },
                        {
                            caption: i18n.t('accountBalancesItems.specificSymbol'),
                            name: "specificSymbol",
                            type: "string"
                        }
                    ]
                }
        }
    },
    OperationQueryDefinition(operationDefinition, {currencies, accounts, parties, users}) {
        return {
            fields: [
                {
                    caption: "Stav",
                    name: "actualStatus",
                    type: "enum",
                    options: [{id: "DRAFT", name: "Draft"}, {id: "LIVE", name: "Živý"}]
                },
                {
                    caption: "Zdroj",
                    name: "source",
                    type: "string"
                },
                {
                    caption: "Datum vytvoření",
                    name: "createdTimestamp",
                    type: "date",
                },
                {
                    caption: "Datum úpravy",
                    name: "updatedTimestamp",
                    type: "date",
                },
                {
                    caption: "Vytvořil",
                    name: "creator",
                    type: "entity",
                    options: users
                },
                {
                    caption: "Upravil",
                    name: "updatedBy",
                    type: "entity",
                    options: users
                },
                ...Object.keys(operationDefinition.model.dynaProperties).map(key => operationDefinition.model.dynaProperties[key]).map(param => {
                        let result = {
                            caption: (param.displayName ?? param.name),
                            name: `content.values.${param.name}`,
                            type: param.details.type,
                            precision: param.details.precision,
                        };
                        if (param.details.type == 'ENTITY_REFERENCE') {
                            result.type = 'entity';
                            if (param.details.entityType == 'account') {
                                result.object = "account"
                                result.options = accounts
                            } else if (param.details.entityType == 'currency') {
                                result.object = "currency"
                                result.options = currencies
                            } else if (param.details.entityType == 'party') {
                                result.object = "party"
                                result.options = parties
                            }
                        }
                        if (param.details.type == 'ENUM') {
                            result.type = 'enum';
                            result.options = param.details.enumValues.map(opt => ({
                                id: opt.value,
                                name: opt.name
                            }))
                        }

                        return result;
                    }
                )
            ]
        }
    }
};

export default utils;
